import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LagerplatzStartEtikettResult } from './data/LagerplatzStartEitkettResult';
import { ScanArtikelResult } from './data/ScanArtikelResult';
import { ServerProviderMock } from './server-provider-mock';

export interface IServerProvider {
    scanLagerplatzStartEtikett(barcode: string): Observable<LagerplatzStartEtikettResult>;

    scanArtikel(eancode: string): Observable<ScanArtikelResult>;

    scanErgebnis(idartstammListe: Array<number>): Observable<boolean>;
}


export class ApiErrors {
    public errors: Array<ApiError> = [];
    public cause: any = null;

    public add(apiError: ApiError): void {
        this.errors.push(apiError);
    }

    public errorString() {
        let str = '';
        for (const err of this.errors) {
            if (str) {
                str += ', ';
            }
            str += err.message;
        }
        return str;
    }
}

export class ApiError {
    constructor(
        public message: string,
        public field: string = null
    ) {
    }
}

@Injectable()
export class ServerProvider implements IServerProvider {

    private serverProvider: IServerProvider;

    constructor() {
        this.serverProvider = new ServerProviderMock();
    }

    public scanLagerplatzStartEtikett(barcode: string): Observable<LagerplatzStartEtikettResult> {
        return this.serverProvider.scanLagerplatzStartEtikett(barcode);
    }

    public scanArtikel(eancode: string): Observable<ScanArtikelResult> {
        return this.serverProvider.scanArtikel(eancode);
    }

    public scanErgebnis(idartstammListe: number[]): Observable<boolean> {
        return this.serverProvider.scanErgebnis(idartstammListe);
    }
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/server-provider.ts